/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

// CHILDREN
import Toast from '../../../common/Toast'

// ASSETS
import './FlagRow.scss'

class FlagRow extends Component {
  render() {
    const { flag, deleteFlag, toggleEditFlag, t } = this.props
    const representativeName = `${flag.representative.first_name} ${
      flag.representative.last_name
    }`
    return (
      <div id='FlagRow'>
        <div className='note-header'>
          <div className='note-info-wrapper'>
            <h4>
              <span>{t('communities.flags.noteLabel')}</span> {flag.note}
            </h4>
          </div>
          <div className='note-date-container'>
            <p className='created-at'>{moment(flag.created_at).fromNow()}</p>
            <div className='note-action-container'>
              <button
                className='note-edit'
                onClick={() => toggleEditFlag(flag)}
              >
                <i className='fa fa-pencil-square-o' />
              </button>
              <Toast
                type={'warn'}
                position={'top_center'}
                message={t('communities.flags.confirmDeleteFlag', {
                  name: representativeName,
                })}
                autoClose={false}
                action={() => deleteFlag(flag.id)}
                actionText={t('communities.flags.yesDeleteFlag')}
              >
                <button className='note-delete'>
                  <i className='fa fa-trash-o' />
                </button>
              </Toast>
            </div>
          </div>
        </div>

        <div className='note-container'>
          <p>{t('communities.flags.createdBy', { name: representativeName })}</p>
          <p
            className='resolved-pill'
            style={{ backgroundColor: this._renderResolvedColor() }}
          >
            {this._renderIsResolved()}
          </p>
          <p className='flag-type-pill'>{flag.flag_type}</p>
        </div>
      </div>
    )
  }

  _renderIsResolved = () => {
    const {
      t,
      flag: { is_resolved },
    } = this.props

    if (is_resolved) {
      return t('communities.flags.resolved')
    }
    return t('communities.flags.unresolved')
  }

  _renderResolvedColor = () => {
    const {
      flag: { is_resolved },
    } = this.props

    if (is_resolved) {
      return '#33d9b2'
    }
    return '#ed213a'
  }
}

export default withTranslation()(FlagRow)
